var _rect, _g, _path, _line, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    transform: "matrix(1 0 0 -1 0 64.2964)",
    fill: "url(#paint0_linear_957_1980)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_957_1980)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    transform: "matrix(1 0 0 -1 10 74.2964)",
    fill: "#EEEEEE",
    fillOpacity: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 63,
    height: 63,
    rx: 14.5,
    transform: "matrix(1 0 0 -1 10 73.2964)",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4729 48.4749C33.2888 47.0576 31.6232 44.9703 30.726 42.5262C29.8287 40.0821 29.7481 37.4129 30.4962 34.9191C31.2444 32.4253 32.781 30.2414 34.8755 28.6948C36.97 27.1483 39.5095 26.3226 42.1131 26.3416C44.7166 26.3606 47.2438 27.2232 49.3156 28.8002C51.3873 30.3771 52.8919 32.5833 53.6036 35.0877C54.3153 37.5922 54.1957 40.2599 53.2629 42.6906C52.33 45.1214 50.6342 47.1841 48.4297 48.5694",
    stroke: "#85951E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 52.2959,
    x2: 47,
    y2: 52.2959,
    stroke: "#85951E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6094 55.2607C37.0571 55.2607 36.5986 55.7137 36.7187 56.2528C36.9317 57.2093 37.4499 58.0959 38.2203 58.7963C39.2517 59.734 40.6507 60.2607 42.1094 60.2607C43.5681 60.2607 44.967 59.734 45.9985 58.7963C46.7688 58.0959 47.2871 57.2093 47.5001 56.2528C47.6201 55.7137 47.1617 55.2607 46.6094 55.2607L42.1094 55.2607L37.6094 55.2607Z",
    fill: "#85951E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_957_1980",
    x: 2,
    y: 2.29639,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_957_1980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_957_1980",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_957_1980",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85951E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0EE11",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/Innovation.da21d4aee694fd24ae948cbaa26e46d5.svg";
export { ForwardRef as ReactComponent };